import { FC, useState } from 'react';
import { QEFormEntryMode, QuoteExperiencePanel, QuoteExperiencePanelProps } from '../../components/QuoteExperiencePanel/QuoteExperiencePanel.component';
import { QESchemaPanel, QESchemaPanelProps } from './QuoteExperienceSchema.panel';

export interface QuoteExperienceSchemaPanelWrapperProps
    extends Omit<QuoteExperiencePanelProps, 'formMode' | 'onFormModeToggle'>,
    Omit<QESchemaPanelProps, 'formMode' | 'onFormModeToggle'> { }

export const QuoteExperienceSchemaPanelWrapper: FC<QuoteExperienceSchemaPanelWrapperProps> = ({
    schema,
    schemaType,
    current,
    extraErrorsByPointer,
    imagePreviewMap,
    updateData,
    defaultMode = 'form',
    ...panelProps
}) => {
    const [formMode, setFormMode] = useState<QEFormEntryMode>(defaultMode);

    return (
        <QuoteExperiencePanel {...panelProps} defaultMode={defaultMode} formMode={formMode} onFormModeToggle={setFormMode}>
            <QESchemaPanel
                schema={schema}
                schemaType={schemaType}
                current={current}
                extraErrorsByPointer={extraErrorsByPointer}
                imagePreviewMap={imagePreviewMap}
                updateData={updateData}
                formMode={formMode}
                onFormModeToggle={setFormMode}
            />
        </QuoteExperiencePanel>
    );
};
